import { render, staticRenderFns } from "./footer-detail.vue?vue&type=template&id=50cf5b8e&scoped=true"
import script from "./footer-detail.vue?vue&type=script&lang=js"
export * from "./footer-detail.vue?vue&type=script&lang=js"
import style0 from "./footer-detail.vue?vue&type=style&index=0&id=50cf5b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf5b8e",
  null
  
)

export default component.exports